import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const ContactPage = () => {

  const pageVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={pageVariants}
      className="min-h-screen bg-gray-50"
    >
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-brand-navy to-brand-gray text-white py-20">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <motion.h1 
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="text-4xl md:text-6xl font-bold mb-6"
            >
              İletişim
            </motion.h1>
            <motion.p 
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="text-xl md:text-2xl max-w-2xl mx-auto"
            >
              Projeleriniz için bizimle iletişime geçin. Size en uygun çözümleri sunmaya hazırız.
            </motion.p>
          </div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              {/* Contact Information */}
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3 }}
                className="bg-white rounded-lg shadow-lg p-8"
              >
                <h2 className="text-3xl font-bold text-brand-navy mb-6">İletişim Bilgileri</h2>
                
                <div className="space-y-6">
                  <div className="flex items-start">
                    <Phone className="w-6 h-6 text-brand-orange mr-4 mt-1" />
                    <div>
                      <h3 className="text-lg font-semibold text-brand-navy">Telefon</h3>
                      <p className="text-brand-gray">(0356) 527 86 65</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <Mail className="w-6 h-6 text-brand-orange mr-4 mt-1" />
                    <div>
                      <h3 className="text-lg font-semibold text-brand-navy">E-posta</h3>
                      <p className="text-brand-gray">info@onurbeton.com.tr</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <MapPin className="w-6 h-6 text-brand-orange mr-4 mt-1" />
                    <div>
                      <h3 className="text-lg font-semibold text-brand-navy">Adres</h3>
                      <p className="text-brand-gray">
                        Kültür, Atatürk Bulv. No:125/A<br />
                        60600 Niksar/Tokat
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <Clock className="w-6 h-6 text-brand-orange mr-4 mt-1" />
                    <div>
                      <h3 className="text-lg font-semibold text-brand-navy">Çalışma Saatleri</h3>
                      <p className="text-brand-gray">Pazartesi - Cuma: 08:00 - 17:00</p>
                      <p className="text-brand-gray">Cumartesi: 08:00 - 12:00</p>
                      <p className="text-brand-gray">Pazar: Kapalı</p>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Map */}
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.5 }}
                className="bg-white rounded-lg shadow-lg p-4"
              >
                <h2 className="text-3xl font-bold text-brand-navy mb-6">Konum</h2>
                <div className="rounded-lg overflow-hidden">
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.456789012345!2d36.9470087!3d40.5815426!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x407d1ab5bcdd405d%3A0x7387e9775d7abb84!2zS8O8bHTDvHIsIEF0YXTDvHJrIEJ1bHYuIE5vOjEyNS9BLCA2MDYwMCBOaWtzYXIvVG9rYXQ!5e0!3m2!1str!2str!4v1753443838520!5m2!1str!2str&z=17" 
                    width="100%" 
                    height="450" 
                    style={{border:0}} 
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    className="rounded-lg"
                  ></iframe>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default ContactPage;
